(() => {
  
  const DIWALI = new Date('2026-11-08T00:00:00+05:30');
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const inr = paise => '₹' + (paise / 100).toLocaleString('en-IN', { maximumFractionDigits: paise % 100 ? 2 : 0, minimumFractionDigits: paise % 100 ? 2 : 0 });
  

  /* ---------- Header ---------- */
  const header = $('.site-header');
  const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 40);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  const menuBtn = $('#menuBtn'), nav = $('#nav');
  const setMenu = open => {
    menuBtn.setAttribute('aria-expanded', open);
    nav.classList.toggle('open', open);
    header.classList.toggle('menu-open', open);
    document.body.classList.toggle('menu-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  };
  menuBtn.addEventListener('click', () => setMenu(menuBtn.getAttribute('aria-expanded') !== 'true'));
  $$('a', nav).forEach(a => a.addEventListener('click', () => setMenu(false)));

  /* ---------- Reveal on scroll ---------- */
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      e.target.classList.add('in');
      io.unobserve(e.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  $$('.reveal').forEach((el, i) => {
    el.style.transitionDelay = `${(i % 4) * 70}ms`;
    io.observe(el);
  });

  /* ---------- Lab range bars ---------- */
  $$('.test-row[data-v]').forEach(row => {
    const { v, lo, hi, min, max } = Object.fromEntries(Object.entries(row.dataset).map(([k, x]) => [k, parseFloat(x)]));
    const pct = x => `${((x - min) / (max - min)) * 100}%`;
    row.style.setProperty('--zl', pct(lo));
    row.style.setProperty('--zw', `${((hi - lo) / (max - min)) * 100}%`);
    row.style.setProperty('--dx', pct(v));
  });

  /* ---------- Lab report lightbox ---------- */
  const dlg = $('#docDialog');
  if (dlg) {
    $('#docOpen').addEventListener('click', () => dlg.showModal());
    $('#docClose').addEventListener('click', () => dlg.close());
    dlg.addEventListener('click', e => { if (e.target === dlg) dlg.close(); });
  }

  /* ---------- Diwali countdown ---------- */
  const days = Math.ceil((DIWALI - new Date()) / 864e5);
  $$('[data-countdown]').forEach(el => {
    if (days > 0 && days < 60) { $('[data-days]', el).textContent = days; el.hidden = false; }
  });


  /* ---------- Toast ---------- */
  const toast = $('#toast');
  let toastTimer;
  const showToast = html => {
    toast.innerHTML = html;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('show'), 2600);
  };

  /* ---------- Quantity steppers ---------- */
  $$('.qty[data-stepper]').forEach(q => {
    const out = $('output', q);
    $$('button', q).forEach(b => b.addEventListener('click', () => {
      out.textContent = Math.min(20, Math.max(1, +out.textContent + +b.dataset.step));
    }));
  });

  /* ---------- Bag (Shopify cart) ---------- */
  const post = (url, body) => fetch(url, {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
  }).then(async r => { const d = await r.json().catch(() => ({})); if (!r.ok) throw new Error(d.description || d.message || 'Could not update your bag'); return d; });
  const getCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());

  const drawer = $('#drawer'), scrim = $('#scrim'), bagBtn = $('#bagOpen');
  const openBag = () => {
    scrim.hidden = false;
    requestAnimationFrame(() => { scrim.classList.add('on'); drawer.classList.add('open'); });
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    $('#bagClose').focus();
  };
  const closeBag = () => {
    scrim.classList.remove('on');
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(() => { scrim.hidden = true; }, 350);
  };
  bagBtn.addEventListener('click', openBag);
  $('#bagClose').addEventListener('click', closeBag);
  scrim.addEventListener('click', closeBag);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer.classList.contains('open')) closeBag(); });

  const renderBag = cart => {
    const badge = $('#bagCount');
    badge.hidden = cart.item_count === 0;
    badge.textContent = cart.item_count;
    $('#bagTotal').textContent = inr(cart.total_price);
    const discRow = $('#bagDiscountRow');
    if (discRow) {
      discRow.hidden = !cart.total_discount;
      $('#bagDiscount').textContent = cart.total_discount ? `− ${inr(cart.total_discount)}` : '';
    }
    const codes = (cart.discount_codes || []).filter(c => c.applicable);
    if (codes.length && $('#promoMsg') && !$('#promoMsg').textContent) {
      $('#promoMsg').textContent = `Code ${codes.map(c => c.code).join(', ')} applied.`;
      $('#promoMsg').className = 'promo-msg ok';
    }
    const up = $('#bagUpsell');
    if (up && window.GC.giftVariant) {
      const hasGift = cart.items.some(i => i.variant_id === window.GC.giftVariant);
      up.hidden = !cart.items.length || hasGift;
      if (!up.hidden) up.innerHTML = `
        <img src="${window.GC.giftImage}" alt="" width="56" height="56">
        <div><b>Gifting someone this Diwali?</b><span>Add a 200 ml jar · ${inr(window.GC.giftPrice)}</span></div>
        <button class="btn btn-ox" type="button" data-upsell>+ Add</button>`;
    }
    $('#bagList').innerHTML = cart.items.length ? cart.items.map(i => `
      <div class="bag-item" data-key="${i.key}" data-qty="${i.quantity}">
        <img src="${i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : ''}" alt="" width="64" height="64">
        <div>
          <h4>${i.variant_title || i.product_title} jar</h4>
          <div class="meta">A2 Gir cow ghee · ${inr(i.final_price)}</div>
          <div class="qty" role="group" aria-label="Quantity">
            <button type="button" data-d="-1" aria-label="Decrease">−</button><output>${i.quantity}</output><button type="button" data-d="1" aria-label="Increase">+</button>
          </div>
        </div>
        <div><div class="line">${inr(i.final_line_price)}</div><button class="rm" type="button">Remove</button></div>
      </div>`).join('')
      : `<div class="bag-empty"><img src="${window.GC.markUrl || ''}" alt=""><p>Your bag is empty.</p><a href="${window.GC.productUrl}" class="btn btn-ox">Shop the ghee</a></div>`;
    const checkout = $('#bagCheckout');
    checkout.href = '/checkout';
    if (cart.items.length) checkout.removeAttribute('aria-disabled'); else checkout.setAttribute('aria-disabled', 'true');
  };

  $('#bagList').addEventListener('click', async e => {
    const item = e.target.closest('.bag-item');
    if (!item) return;
    const step = e.target.closest('[data-d]');
    let q = +item.dataset.qty;
    if (step) q += +step.dataset.d;
    else if (e.target.closest('.rm')) q = 0;
    else return;
    try { renderBag(await post('/cart/change.js', { id: item.dataset.key, quantity: Math.max(0, q) })); }
    catch (err) { showToast(err.message); }
  });

  const addToCart = async (id, quantity) => {
    await post('/cart/add.js', { items: [{ id: Number(id), quantity }] });
    const cart = await getCart();
    renderBag(cart);
    return cart;
  };

  // Any block with data-variant and a [data-add] / [data-buy] button.
  $$('[data-variant]').forEach(block => {
    const out = $('.qty[data-stepper] output', block);
    const qty = () => (out ? +out.textContent : 1);
    $$('[data-add]', block).forEach(btn => btn.addEventListener('click', async () => {
      btn.disabled = true;
      try {
        await addToCart(block.dataset.variant, qty());
        const size = $('.product-size', block)?.textContent
          || $('[data-size-picker] input:checked + span b', block)?.textContent
          || $('[data-size-select] option:checked', block)?.textContent.split(' · ')[0]
          || $('#sizePicker input:checked + .so-size')?.textContent || '';
        showToast(`Added <b>${qty()} × ${size}</b> to your bag · <a href="/checkout">Checkout</a>`);
        if (out) out.textContent = 1;
        bagBtn.classList.remove('bump'); void bagBtn.offsetWidth; bagBtn.classList.add('bump');
      } catch (err) { showToast(err.message); }
      btn.disabled = false;
    }));
    $$('[data-buy]', block).forEach(btn => btn.addEventListener('click', async () => {
      btn.disabled = true;
      try { await addToCart(block.dataset.variant, qty()); location.href = '/checkout'; }
      catch (err) { showToast(err.message); btn.disabled = false; }
    }));
  });

  /* ---------- Product page: size picker + gallery ---------- */
  const picker = $('#sizePicker');
  if (picker) {
    const block = picker.closest('[data-variant]');
    const main = $('#galleryMain');
    const addBtn = $('[data-add]', block), buyBtn = $('[data-buy]', block);
    const setVariant = (id, updateUrl = true) => {
      const input = $(`input[value="${id}"]`, picker);
      if (!input) return;
      input.checked = true;
      block.dataset.variant = id;
      const price = +input.dataset.price, ml = +input.dataset.ml;
      $('#pdpPrice').textContent = inr(price);
      $('#pdpPerMl').textContent = `${inr(Math.round(price / ml))} per ml`;
      main.src = input.dataset.image;
      main.alt = `${$('.so-size', input.parentElement).textContent} jar of Ghee Culture A2 Gir cow ghee`;
      $$('.thumb').forEach(t => t.setAttribute('aria-pressed', t.dataset.variantId === String(id)));
      const available = input.dataset.available === 'true';
      addBtn.disabled = buyBtn.disabled = !available;
      addBtn.textContent = available ? 'Add to bag' : 'Sold out';
      if (updateUrl) history.replaceState(null, '', `?variant=${id}${location.hash}`);
    };
    // ?size=200|500|1000 links from the home page and footer
    const sizeParam = new URLSearchParams(location.search).get('size');
    const bySize = sizeParam && $(`input[data-ml="${sizeParam}"]`, picker);
    setVariant(bySize ? bySize.value : $('input:checked', picker).value, Boolean(bySize));
    picker.addEventListener('change', e => setVariant(e.target.value));
    $$('.thumb').forEach(t => t.addEventListener('click', () => setVariant(t.dataset.variantId)));
  }

  /* ---------- Corporate: box explorer tabs ---------- */
  const tabs = $$('.bx-tab');
  const showBox = key => {
    tabs.forEach(t => t.setAttribute('aria-selected', String(t.dataset.box === key)));
    $$('.bx-panel').forEach(p => { p.hidden = p.id !== `panel-${key}`; });
  };
  tabs.forEach((t, i) => {
    t.addEventListener('click', () => showBox(t.dataset.box));
    t.addEventListener('keydown', e => {
      const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      if (!d) return;
      const n = tabs[(i + d + tabs.length) % tabs.length];
      n.focus(); showBox(n.dataset.box);
    });
  });

  /* ---------- Corporate: order planner ---------- */
  const gift = $('#giftForm');
  if (gift) {
    const rows = $$('.pl-row', gift);
    const qtyInput = r => $('[data-qty]', r);
    const qtyOf = r => Math.max(0, Math.floor(+qtyInput(r).value || 0));
    const nameOf = r => $('strong', r).textContent;
    const checkRow = (r, show) => {
      const q = qtyOf(r), min = +r.dataset.min, bad = q > 0 && q < min;
      r.classList.toggle('invalid', bad && show);
      $('.pl-err', r).textContent = bad && show ? `Minimum ${min} boxes for ${nameOf(r)}.` : '';
      return !bad;
    };
    const update = () => {
      let total = 0;
      const lines = rows.filter(r => qtyOf(r) > 0).map(r => {
        const sum = qtyOf(r) * +r.dataset.price; total += sum;
        return `<div class="pl-line"><span>${qtyOf(r)} × ${nameOf(r)}</span><span>${inr(sum * 100)}</span></div>`;
      });
      $('#plLines').innerHTML = lines.join('') || '<p class="pl-empty">Add boxes to see an estimate.</p>';
      $('#plTotal').textContent = inr(total * 100);
      $('#plBespoke').hidden = qtyOf(rows.find(r => r.dataset.box === 'bespoke')) === 0;
      rows.forEach(r => { if (r.classList.contains('invalid')) checkRow(r, true); });
    };
    rows.forEach(r => {
      const input = qtyInput(r), min = +r.dataset.min;
      $$('[data-q]', r).forEach(btn => btn.addEventListener('click', () => {
        let q = qtyOf(r) + +btn.dataset.q;
        if (+btn.dataset.q > 0 && q < min) q = min;      // first tap jumps to the minimum
        if (+btn.dataset.q < 0 && q < min) q = 0;        // going below the minimum clears it
        input.value = q; update(); checkRow(r, true);
      }));
      input.addEventListener('input', update);
      input.addEventListener('blur', () => checkRow(r, true));
    });
    $$('.chips[data-limit]', gift).forEach(group => {
      const limit = +group.dataset.limit, counter = $('#' + group.dataset.counter);
      const sync = () => {
        const boxes = $$('input', group), picked = boxes.filter(b => b.checked).length;
        boxes.forEach(b => { b.disabled = !b.checked && picked >= limit; });
        counter.textContent = `${picked}/${limit}`;
        const own = $('input[value="Your own idea"]', group);
        if (own) $('#ownIdea').hidden = !own.checked;
      };
      group.addEventListener('change', sync); sync();
    });
    // "Plan … order" buttons in the explorer preselect that box at its minimum
    $$('[data-plan]').forEach(btn => btn.addEventListener('click', () => {
      const r = rows.find(x => x.dataset.box === btn.dataset.plan);
      if (r && qtyOf(r) === 0) qtyInput(r).value = r.dataset.min;
      update();
      $('#enquire').scrollIntoView({ behavior: 'smooth' });
    }));
    gift.addEventListener('submit', e => {
      const ok = rows.map(r => checkRow(r, true)).every(Boolean);
      const any = rows.some(r => qtyOf(r) > 0);
      $('#plQtyErr').textContent = any ? '' : 'Add at least one box.';
      if (!ok || !any) { e.preventDefault(); $('.pl-rows', gift).scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      const f = new FormData(gift);
      let total = 0;
      const lines = rows.filter(r => qtyOf(r) > 0).map(r => { total += qtyOf(r) * +r.dataset.price; return `${qtyOf(r)} × ${nameOf(r)} (₹${(+r.dataset.price).toLocaleString('en-IN')} each)`; });
      const bespoke = !$('#plBespoke').hidden ? [
        `Bespoke dry fruits: ${f.getAll('fruit').join(', ') || 'Not decided yet'}`,
        `Bespoke keepsakes: ${f.getAll('gift').join(', ') || 'Not decided yet'}`
      ] : [];
      $('#plBody').value = ['Corporate gifting enquiry', ...lines, `Estimated total: ₹${total.toLocaleString('en-IN')}`, ...bespoke].join('\n');
    });
    update();
    const done = $('#giftDone');
    if (done) { done.scrollIntoView({ block: 'center' }); done.focus(); }
  }

  /* ---------- Size pickers in the hero buy box and sticky bar ---------- */
  const setBlockVariant = (block, id, price) => {
    block.dataset.variant = id;
    $$('[data-price]', block).forEach(el => { if (!el.matches('input, option')) el.textContent = inr(+price); });
  };
  $$('[data-size-picker]').forEach(group => group.addEventListener('change', e => {
    setBlockVariant(group.closest('[data-variant]'), e.target.value, e.target.dataset.price);
  }));
  $$('[data-size-select]').forEach(sel => sel.addEventListener('change', () => {
    const opt = sel.selectedOptions[0];
    setBlockVariant(sel.closest('[data-variant]'), opt.value, opt.dataset.price);
  }));

  /* ---------- Sticky add-to-bag bar ---------- */
  const sticky = $('#stickyBuy');
  const anchor = $('#heroBuy') || $('.pdp-buy');
  if (sticky && anchor) {
    new IntersectionObserver(([e]) => {
      const show = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('show', show);
      sticky.setAttribute('aria-hidden', String(!show));
      document.body.classList.toggle('has-sticky', show);
    }).observe(anchor);
  }

  /* ---------- Promo code ---------- */
  const promo = $('#promoForm');
  if (promo) {
    promo.addEventListener('submit', async e => {
      e.preventDefault();
      const code = promo.code.value.trim().toUpperCase();
      const msg = $('#promoMsg');
      if (!code) return;
      msg.className = 'promo-msg'; msg.textContent = 'Checking…';
      try {
        const cart = await post('/cart/update.js', { discount: code });
        const found = (cart.discount_codes || []).find(c => c.code.toUpperCase() === code);
        if (found && found.applicable) { msg.textContent = `Code ${code} applied.`; msg.className = 'promo-msg ok'; }
        else if (found) { msg.textContent = `Code ${code} saved. It will apply at checkout if your order qualifies.`; msg.className = 'promo-msg'; }
        else { msg.textContent = `We couldn't find the code ${code}.`; msg.className = 'promo-msg err'; }
        renderBag(cart);
      } catch {
        // Older cart API: fall back to Shopify's discount link, applied at checkout
        await fetch(`/discount/${encodeURIComponent(code)}`).catch(() => {});
        msg.textContent = `Code ${code} will be applied at checkout.`; msg.className = 'promo-msg ok';
      }
    });
  }

  /* ---------- Gift add-on in the bag ---------- */
  $('#bagUpsell')?.addEventListener('click', async e => {
    if (!e.target.closest('[data-upsell]')) return;
    try { await addToCart(window.GC.giftVariant, 1); showToast('Added a <b>200 ml</b> gift jar to your bag'); }
    catch (err) { showToast(err.message); }
  });

  getCart().then(renderBag).catch(() => {});
})();
